import { AutoMap } from "@automapper/classes";

export class DisponibiliteClientDTO {
    @AutoMap()
    from!: string;
    @AutoMap()
    to!: string;
}